<template>
  <footer class="footer">
    <div class="footer-inner">
      <nav class="footer-links" aria-label="Footer links">
        <router-link
          v-for="link in footerLinks"
          :key="link.to"
          :to="link.to"
          class="footer-link"
        >
          {{ link.label }}
        </router-link>
      </nav>
      <p class="footer-note">
        &copy; 2026
        <router-link to="/" class="footer-link">wagbappro.id</router-link>
        — Situs panduan dan informasi WA GB APK. Hak cipta milik pemilik masing-masing.
      </p>
    </div>
  </footer>
</template>

<script>
import siteConfig from '@/config/site';

export default {
  name: 'Footer',
  data() {
    return {
      footerLinks: siteConfig.footerLinks,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  margin-top: 8px;
  padding: 18px var(--wagb-content-edge, clamp(18px, 3.2vw, 44px)) 22px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
}

.footer-inner {
  width: 100%;
  max-width: 920px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px 14px;
}

.footer-link {
  color: #1b6ca8;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #2880ba;
    text-decoration: underline;
  }
}

.footer-note {
  margin: 0;
  max-width: 640px;
  font-size: 12px;
  line-height: 1.55;
  color: #94a3b8;

  .footer-link {
    font-size: inherit;
    font-weight: 700;
    color: #64748b;

    &:hover {
      color: #1b6ca8;
    }
  }
}

@media (max-width: 768px) {
  .footer {
    padding-top: 14px;
    padding-bottom: 18px;
  }

  .footer-inner {
    gap: 8px;
  }

  .footer-links {
    gap: 4px 12px;
  }

  .footer-link {
    font-size: 13px;
  }

  .footer-note {
    font-size: 11px;
    line-height: 1.5;
  }
}
</style>
